export const OPEN_CONFIRM_MODAL = 'confirmModal/OPEN';
export const CLOSE_CONFIRM_MODAL = 'confirmModal/CLOSE';
export const CONFIRM_MODAL_CONFIRM = 'confirmModal/CONFIRM';
export const CONFIRM_MODAL_NEGATIVE = 'confirmModal/NEGATIVE';
